import React, { memo, useEffect, useState } from "react";
import SelectInputMap, { OptionType } from "../../InputForms/SelectInputMap/SelectInputMap";
import { getCityLocalStorage } from "../../../../../store/localStorage/city";
import useQueryRoute from "../../../hooks/useQueryRoute";
import useCity from "../../../hooks/useCity";
import apiCities from "../../../../../api/cityes/apiCities";
import { closeNavTab } from "../../../../../shared/components/NavTab/fuctionsControl";


interface InputSelectCityProps {
    citiesInputOptions: OptionType[];
    handleSelectCitiy: (city: OptionType) => void;
    isLoadingCities: boolean;
    label?: string;
    isCityTo?: boolean;
    isDisabled?: boolean;
}

const InputSelectCity: React.FC<InputSelectCityProps> = ({
    citiesInputOptions,
    handleSelectCitiy,
    isLoadingCities,
    label,
    isCityTo = false,
    isDisabled = false,
}) => {
    const { dataQueryRoute } = useQueryRoute();
    const [initSelectedValue, setinitSelectedValue] = useState<any>();
    const [selectedValue, setSelectedValue] = useState<any>();
    const { city, cityTo, selectCity, selectCityTo } = useCity();

    function onChange(event: OptionType) {
        handleSelectCitiy(event)
    }

    function onClear() {
        handleSelectCitiy(null);
        setSelectedValue(null);
        closeNavTab();
    }

    useEffect(() => {
        if (isCityTo) {
            if (cityTo) {
                setSelectedValue({ value: cityTo.id, label: cityTo.name })
                selectCityTo(cityTo);
            } else {
                setSelectedValue(null)
            }
        }
        if (!isCityTo) {
            if (city) {
                setSelectedValue({ value: city.id, label: city.name })
                selectCity(city);
            }
        }
    }, [city, cityTo, isCityTo])

    // async function init() {
    //     try {

    //         if (dataQueryRoute === undefined) {
    //             console.log('dataQueryRoute is undefined')
    //             if (!isCityTo) {
    //                 const city = getCityLocalStorage();
    //                 if (city) {
    //                     setinitSelectedValue({ value: city.id, label: city.name })
    //                     selectCity(city);
    //                 }
    //             } else {
    //                 if (cityTo) {

    //                 }
    //             }
    //         } else if (dataQueryRoute) {
    //             const res = await apiCities.getCities({});
    //             const cities = Object.values(res.cities);
    //             const finded = cities.find(c => c.id.toString() === dataQueryRoute.cityId);
    //             if (finded) {
    //                 setinitSelectedValue({ value: finded.id, label: finded.name })
    //                 selectCity(finded, false);
    //             }
    //         }
    //     }
    //     catch (err) {

    //     }
    // }

    // useEffect(() => {
    //     init();
    // }, [dataQueryRoute, cityTo])

    return (
        <SelectInputMap
            selectedValue={selectedValue}
            placeholder='Выберите населенный пункт'
            options={citiesInputOptions}
            // @ts-ignore
            onChange={onChange}
            isLoading={isLoadingCities}
            initSelectedValue={initSelectedValue}
            onClear={onClear}
            isDisabled={isDisabled}
        />
    )
}

export default memo(InputSelectCity);